import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'agent/edgar', pathMatch: 'full' },
  {
    path: 'agent',
    loadChildren: () => import('./kng-sgc/kng-sgc.module').then(m => m.KngSgcModule),
  },
  {
    path: 'tarifs',
    loadComponent: () => import('./kng-owner-exception/kng-owner-exceptions.component').then(m => m.OwnerExceptionsComponent),
  },
  {
    path: 'legal',
    loadChildren: () => import('./kng-legal/kng-legal.module').then(m => m.KngLegalModule),
  },
  {
    path: 'billing',
    loadComponent: () => import('./kng-legal/kng-legal-billing/kng-legal-billing.component').then(m => m.KngLegalBillingComponent),
  },
  { path: '**', redirectTo: 'agent/edgar', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
